<template>
  <article class="question">
    <div class="column">
      <p class="text">{{ question }}</p>
      <div class="rating-wrapper">
        <StarRating
          class="star-rating"
          @rating-selected="onRatingChange"
          :rating="value"
          :star-size="34"
          :increment="1"
          :show-rating="false"
          active-color="#E9A43D"
          active-border-color="#E9A43D"
          inactive-color="#ffffff"
          border-color="#C5C3C3"
          :border-width="2"
          :padding="4"
          rounded-corners
        />
        <span class="hint">Most satisfied</span>
      </div>
    </div>
  </article>
</template>

<script>
// @ts-ignore
import StarRating from 'vue-star-rating';

export default {
  components: {
    StarRating,
  },
  props: ['value', 'question'],
  methods: {
    onRatingChange(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped lang="scss">
@import './question.scss';

.rating-wrapper {
  margin-left: 40px;
  width: 210px;
  text-align: right;
}

.star-rating {
  display: inline-block;
  text-align: right;
}

.hint {
  display: inline-block;
  margin-right: 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 140%;
  text-align: right;
  color: #c5c3c3;
}
</style>
